import { AsyncPipe, NgComponentOutlet } from '@angular/common'
import { afterNextRender, ChangeDetectionStrategy, Component, computed, Inject, signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { TranslateModule } from '@ngx-translate/core'

import { UserSectionAccessComponent } from '~/core/components'
import { COMPANY_FACADE, ICompanyFacade, IRouterFacade, ROUTER_FACADE } from '~/core/features'
import { EGuardSection } from '~/core/models'
import { LoadingComponent } from '~/ui/loading'

import { StockPricePredictionsInfoComponent } from './components'

@Component({
  selector: 'app-stock-price-predictions',
  templateUrl: './stock-price-predictions.component.html',
  styleUrl: './stock-price-predictions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    TranslateModule,
    LoadingComponent,
    NgComponentOutlet,
    UserSectionAccessComponent,
    StockPricePredictionsInfoComponent,
  ],
})
export class StockPricePredictionsComponent {
  contourChartComponent = signal<Promise<any> | null>(null)
  impactIsolinesChartComponent = signal<Promise<any> | null>(null)

  readonly forecast = toSignal(this.companyFacade.forecast$)

  readonly guardSection = computed(() =>
    this.isCompanyPage() ? EGuardSection.COMPANY_INFO_SCENARIOS : EGuardSection.FORECAST_INFO_SCENARIOS
  )

  readonly guardEpsContourChart = computed(() =>
    this.isCompanyPage() ? EGuardSection.COMPANY_INFO_CHART_EPS_CONTOUR : EGuardSection.FORECAST_INFO_CHART_EPS_CONTOUR
  )

  readonly guardImpactIsoLinesChart = computed(() =>
    this.isCompanyPage()
      ? EGuardSection.COMPANY_INFO_CHART_IMPACT_ISOLINES
      : EGuardSection.FORECAST_INFO_CHART_IMPACT_ISOLINES
  )

  private readonly isCompanyPage = toSignal(this.routerFacade.isCompanyPage$)

  constructor(
    @Inject(ROUTER_FACADE) public routerFacade: IRouterFacade,
    @Inject(COMPANY_FACADE) private companyFacade: ICompanyFacade
  ) {
    afterNextRender(() => {
      this.contourChartComponent.set(
        import('./lazy-components/contour-chart-container/contour-chart-container.component').then(
          c => c.ContourChartContainerComponent
        )
      )

      this.impactIsolinesChartComponent.set(
        import('./lazy-components/impact-isolines-chart-container/impact-isolines-chart-container.component').then(
          c => c.ImpactIsolinesChartContainerComponent
        )
      )
    })
  }
}
